import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ChangeDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/change-dto';

@Component({
    selector: 'app-recent-changes',
    templateUrl: './recent-changes.component.html',
    styleUrls: ['./recent-changes.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RecentChangesComponent implements OnInit {
  @Input() changes: ChangeDto[];

  constructor() {}

  ngOnInit(): void {}
}
